/**
 * Tailwind classes for `LoadingSkeleton`, built only from the tokens in
 * `src/styles/globals.css`.
 *
 * `bg-surface-sunken` rather than a shimmer gradient: it is the token that
 * already means "unfilled", and a motion-heavy placeholder competes with the
 * content that replaces it.
 */
export const loadingSkeletonStyles = {
  root: 'flex w-full flex-col gap-3',
  row: 'flex w-full flex-col gap-2',
  rowBlock: 'rounded-surface border border-border bg-surface-raised p-4',
  bar: 'h-3 w-full rounded-control bg-surface-sunken',
  barWide: 'w-full',
  barShort: 'w-2/5',
  barTitle: 'h-5 w-1/3 rounded-control bg-surface-sunken',
} as const;
